import React from 'react';
import './CorporateTraining.css';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const CorporateTraining = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <section className="corporate-training" id="corporate-training">
      <div className="corporate-content">
        <h2 className="corporate-heading">{t.corporateTitle}</h2>
        
        <div className="corporate-cards">
          <div className="corporate-image">
            <img 
              src="/images/corporate-workshop-2.jpg" 
              alt="Corporate Workshop 2"
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
          </div>
          <div className="corporate-card">
            <div className="corporate-card-header">
              <h3 className="corporate-card-title">{t.corporateAltTitle}</h3>
              <div className="corporate-card-logo">
                <img 
                  src="/logos/logo-alt-university.png" 
                  alt="ALT University"
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              </div>
            </div>
            <div className="corporate-card-list">
              <div className="corporate-list-item">
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14 2L3 7L14 12L25 7L14 2Z" fill="#33949D"/>
                </svg>
                <p>{t.corporateAltText1}</p>
              </div>
              <div className="corporate-list-item">
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14 2L3 7L14 12L25 7L14 2Z" fill="#33949D"/>
                </svg>
                <p>{t.corporateAltText2}</p>
              </div>
              <div className="corporate-list-item">
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14 2L3 7L14 12L25 7L14 2Z" fill="#33949D"/>
                </svg>
                <p>{t.corporateAltText3}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CorporateTraining;

